import Store from '../redux/store';
import { StateManager } from '../redux/stateManager';
import _ from 'lodash';
// 先拿到缓存的数据 ，如果缓存没有，则获取Store里的初始值
export const getCacheField = (path: string, filterZero?: boolean) => {
  
  let result = StateManager.getFromCache(`${path}`) ? StateManager.getFromCache(`${path}`) : _.get(Store.getState(), `${path}`);
  if(filterZero) result = StateManager.getFromCache(`${path}`)
  return result;
};